var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showDetails)?_c(_setup.Application,{attrs:{"tracker-id":parseInt(_setup.id),"from-preview":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }